import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root is missing from index.html");

// The document direction is what flips the whole layout, so it is derived from
// the saved language and re-applied whenever the language changes.
function applyDir(lang: string) {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "fa" ? "rtl" : "ltr";
}

applyDir(localStorage.getItem("sc.lang") ?? "fa");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
